exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "::ng-deep .my-theme .mat-accent .mat-slider-thumb {\n  background-color: #4b81b0; }\n\n::ng-deep .my-theme .mat-slider-min-value.mat-slider-thumb-label-showing .mat-slider-thumb {\n  background-color: #4b81b0; }\n\n::ng-deep .my-theme .mat-accent .mat-slider-thumb-label {\n  background-color: #4b81b0; }\n\n::ng-deep .my-theme .mat-accent .mat-slider-track-fill {\n  background-color: #4b81b0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/configuracion/configuracion.component.scss
// module id = ../../../../../src/app/components/configuracion/configuracion.component.scss
// module chunks = 0